import { rem } from 'helpers/utils';
import { styled } from '@mui/material/styles';

export const Row = styled('div')(() => ({
  padding: `${rem(15)} 0`
}));

export const SectionSpacer = styled('div')(() => ({
  marginTop: rem(30)
}));

export const VehiclesTable = styled('div')(() => ({
  border: '1px solid #D9D9D9',
  borderRadius: rem(10),
  overflow: 'hidden',
  marginTop: rem(10),

  '& .MuiTable-root': {
    borderCollapse: 'separate',
    borderSpacing: 0
  },

  '& .MuiTableHead-root': {
    backgroundColor: '#F7F7F7'
  },

  '& .MuiTableCell-root': {
    borderBottom: '1px solid #E5E5E5'
  },

  '& .MuiTableCell-head': {
    color: '#585858',
    fontWeight: 700,
    fontSize: rem(13),
    borderBottom: '1px solid #D9D9D9'
  },

  '& .MuiTableCell-body': {
    color: '#656565',
    fontSize: rem(14)
  },

  '& .MuiTableBody-root .MuiTableRow-root:last-of-type .MuiTableCell-root': {
    borderBottom: 'none'
  }
}));

export const FieldList = styled('div')(() => ({
  display: 'flex',
  flexDirection: 'column',
  gap: rem(12),
  marginTop: rem(6),
  marginBottom: rem(20)
}));

export const FieldItem = styled('div')(() => ({
  border: '1px solid #E5E5E5',
  borderRadius: rem(10),
  padding: `${rem(12)} ${rem(16)}`,

  '& .field-header': {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    gap: rem(12)
  },

  '& .field-name': {
    color: '#1A1A1A',
    fontWeight: 700,
    fontSize: rem(14)
  },

  '& .field-value': {
    color: '#2E7D32',
    fontWeight: 700,
    fontSize: rem(15),
    whiteSpace: 'nowrap'
  },

  '& .field-desc': {
    margin: `${rem(6)} 0 0`,
    color: '#7A7A7A',
    fontSize: rem(12.5),
    lineHeight: 1.45
  }
}));

export const CalcCard = styled('div')(() => ({
  border: '1px solid #D9D9D9',
  borderRadius: rem(10),
  padding: `${rem(12)} ${rem(20)}`,
  marginTop: rem(10),

  '& .summary-title': {
    margin: `0 0 ${rem(4)}`,
    fontSize: rem(15),
    fontWeight: 700,
    color: '#1A1A1A'
  },

  '& .summary-note': {
    margin: `${rem(14)} 0 0`,
    fontSize: rem(12.5),
    color: '#7A7A7A',
    lineHeight: 1.45
  }
}));

export const NoteCard = styled('div')(() => ({
  padding: `${rem(12)} ${rem(2)}`,
  marginTop: rem(10),

  '& .summary-note': {
    margin: 0,
    fontSize: rem(12.5),
    color: '#7A7A7A',
    lineHeight: 1.45
  }
}));

export const CalcRow = styled('div')(() => ({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  gap: rem(16),
  padding: `${rem(12)} 0`,
  borderBottom: '1px solid #F0F0F0',

  '&:last-of-type': {
    borderBottom: 'none'
  },

  '& span': {
    color: '#585858',
    fontSize: rem(14)
  },

  '& strong': {
    color: '#1A1A1A',
    fontSize: rem(15),
    whiteSpace: 'nowrap'
  },

  '&.total': {
    '& span': {
      fontWeight: 700,
      color: '#1A1A1A'
    },

    '& strong': {
      fontSize: rem(17),
      color: '#2E7D32'
    }
  }
}));
